import {useEffect,useState} from 'react';
import { useHistory } from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import {Grid, Typography,Card,CardActions,CardContent,Button,IconButton,Tooltip,InputAdornment,InputLabel,Input,TextField, LinearProgress} from '@material-ui/core';
import {makeStyles,withStyles } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import SearchIcon from '@material-ui/icons/Search';
import { Skeleton } from '@material-ui/lab';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {loadSkeleton,DASHBOARD_TEXTS,api,useInterval} from '../utility';
import DashboardAdthriveNewBriefInput from './dashboardAdthriveNewBriefInput';
import {DebounceInput} from 'react-debounce-input';
import * as briefActions from '../actions/briefActions';
import * as currentPageActions from '../actions/currentPageActions';
import _ from 'lodash'

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.primary.main,
    },
  }));
  

function DashboardAdthriveContent(props){
    const dispatch = useDispatch();
    const tooltipClass = useStylesBootstrap();
    const timeAgo = new TimeAgo('en-US')
    const [searchString, setSearchString] = useState("");
    const [newBriefInputOpen, setNewBriefInputOpen] = useState(false);
    const [newUpdateBriefInputOpen, setNewUpdateBriefInputOpen] = useState(false);
    const [newBriefMenuAnchorEl, setNewBriefMenuAnchorEl] = React.useState(null);
    const [tabState, setTabState] = React.useState(0);
    const Briefs = useSelector(state => state.briefs);
    const currentPage = useSelector(state => state.currentPage);
    const loggedInState = useSelector(state => state.auth);
    const history = useHistory();
    const pollDelay = 7000;

    const loadBriefView = (id) => {
      history.push(`/brief/${id}`);
    }

    // when brief is loaded, if it hasn't tried to attempt autoload, then attempt
    useEffect(() => {
        let {shouldTryAutoloading} = currentPage;
        if(shouldTryAutoloading && Briefs && !_.isEmpty(Briefs.briefs) && currentPage.permalink){
            dispatch(currentPageActions.setShouldTryAutoloading(false));
            let briefs = Briefs.briefs.data;
            let matchingBrief = _.find(briefs, {url: currentPage.permalink});
            if(matchingBrief){
                console.log('currentPage: '+currentPage.permalink);
                console.log(matchingBrief);
                loadBriefView(matchingBrief.id);
            }
        }else if(!_.isEmpty(Briefs.activeBrief)){
                console.log("Loading breif after minimizing WP");
                loadBriefView(Briefs.activeBrief.id);
        }
    });

    let isLoading = Briefs.isLoading;
    let briefs;
    if(Briefs && Briefs.briefs && Briefs.briefs.data){
      briefs = Briefs.briefs.data;
      briefs = _.filter(briefs, (brief) => {
        if(searchString.length > 1 && !_.includes(brief.keyword.toLowerCase(), searchString.toLowerCase())){
          return false;
        }else{
          return true;
        }
      });
    }

    if(tabState === 0){ // in progress
        briefs = _.filter(briefs, (brief) => {
            if(brief && brief.status !== 'COMPLETED'){
                return true;
            } else{
                return false;
            }
        });

        briefs = _.sortBy(briefs, (brief) => {
            return new Date(brief.createdAt) * -1
        });
    } else { // completed
        briefs = _.filter(briefs, (brief) => {
            if(brief && brief.status === 'COMPLETED'){
                return true;
            } else{
                return false;
            }
        });

        briefs = _.sortBy(briefs, (brief) => {
            return new Date(brief.completedAt) * -1
        });
    }

    let briefsAreGenerating = _.filter(briefs, {status: 'GENERATING'}).length > 0;
    useInterval(() => {
        dispatch(briefActions.getAdthriveBriefs());
    }, briefsAreGenerating ? pollDelay : null);

    let showSkeleton = isLoading && !briefsAreGenerating;
    let showBriefs = !_.isEmpty(briefs);

    const handleTabChange = (event, newValue) => {
        setTabState(newValue);
    };

    return (
        <Grid container xs="12" md="12" direction="row" spacing={1}>
            <Grid xs="12" item style={{padding:'0.5rem 1.5rem'}}>
                <Typography variant="h6" color="primary" style={{fontWeight:"bold"}}>{DASHBOARD_TEXTS.SEARCH_BRIEF_TEXT_HEADING}</Typography>
            </Grid>
            <Grid xs="12" item style={{textAlign:'center',padding:'0.3rem 1.8rem'}}>
                <Card style={{padding:'0.3rem 2rem', paddingLeft: '14px',borderRadius:'30rem'}}>
                    <Grid container display="flex">
                        <Grid item>
                            <SearchIcon color="primary" size="small" style={{position: 'relative', top: '3px', opacity: '0.6', paddingRight: '6px'}} />
                        </Grid>
                        <Grid item style={{flexGrow: '1'}}>
                            <DebounceInput
                                fullWidth
                                minLength={2}
                                debounceTimeout={300}
                                onChange={(e)=>{setSearchString(e.target.value)}}
                                style={{all: 'initial',marginBottom: '0.4rem', height: '100%', width: '100%', fontFamily: 'inherit'}}
                                placeholder={DASHBOARD_TEXTS.BRIEF_SEARCH_PLACEHOLDER_TEXT}
                                type="text"
                                value={searchString}
                            />
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
            <Grid xs="12" item style={{padding:'0.5rem 1.5rem', marginTop: '21px'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <Typography variant="h6" color="primary" gutterBottom  style={{fontWeight:"bold", flexGrow: 1}}>{DASHBOARD_TEXTS.BRIEF_SUB_HEADING_TEXT}</Typography>
                    <div>
                        <Button variant="contained" color="primary" size="small" onClick={(e) => { setNewBriefMenuAnchorEl(e.currentTarget); }}>+ New</Button>
                        <Menu
                            anchorEl={newBriefMenuAnchorEl}
                            keepMounted
                            open={Boolean(newBriefMenuAnchorEl)}
                            onClose={() => {setNewBriefMenuAnchorEl(null);}}
                          >
                            <MenuItem onClick={() => {setNewBriefInputOpen(true);setNewUpdateBriefInputOpen(false);setNewBriefMenuAnchorEl(null);}}>For New Post</MenuItem>
                            <MenuItem onClick={() => {setNewUpdateBriefInputOpen(true);setNewBriefInputOpen(false);setNewBriefMenuAnchorEl(null);}}>For Existing Post</MenuItem>
                        </Menu>
                    </div>
                </div>
            </Grid>
            <Grid xs="12" item style={{padding:'0 1.5rem'}}>
                <Tabs
                    value={tabState}
                    onChange={handleTabChange} 
                    aria-label="Content Brief Status"
                    indicatorColor="primary"
                >
                  <Tab label="In Progress" />
                  <Tab label="Completed" />
                </Tabs>
            </Grid>
            <Grid xs="12" item style={{padding:'0.5rem 1.5rem'}}>
                {newBriefInputOpen && <DashboardAdthriveNewBriefInput
                                            onCreate={() => {setNewBriefInputOpen(false)}}
                                            type="new"
                                            handleClose={() => {setNewBriefInputOpen(false)}} />}
                {newUpdateBriefInputOpen && <DashboardAdthriveNewBriefInput
                                            onCreate={() => {setNewUpdateBriefInputOpen(false)}}
                                            type="update"
                                            handleClose={() => {setNewUpdateBriefInputOpen(false)}} />}

                {showBriefs &&
                    briefs.map((brief) => {
                        let isGenerating = brief.status === 'GENERATING';
                        let dateMetric = new Date(brief.createdAt)
                        if(brief.status && brief.status === 'COMPLETED' && brief.completedAt){
                            dateMetric = new Date(brief.completedAt)
                        }
                        return (
                            <Card style={{marginBottom:10,borderRadius:'0.3rem',cursor:`${isGenerating ? 'default' : 'pointer'}`}} onClick={()=>{!isGenerating && loadBriefView(brief.id)}} >
                                <CardContent style={{paddingBottom: '13px', padding: '13px'}}>
                                    <Grid container xs="12" direction="row">
                                        <Grid item xs="9">
                                            <Typography variant="body1" color="primary" style={{fontSize: '14px'}}>
                                            {brief.keyword}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="3">
                                            <Typography variant="caption" color="primary" style={{color:'grey'}}>
                                                {!isGenerating && timeAgo.format(dateMetric,'round')}
                                                {isGenerating && "generating..."}
                                            </Typography>
                                        </Grid>
                                        {isGenerating && <Grid item xs="12" style={{marginTop: '5px'}}>
                                            <LinearProgress />
                                        </Grid>}
                                </Grid>
                                </CardContent>
                            </Card>
                    )})
                }
                {!isLoading && _.isEmpty(briefs) && <div style={{marginBottom: '10px'}}>No briefs found</div>}
                {showSkeleton && loadSkeleton('card') }
            </Grid>
                
        </Grid>
    );
}

export default DashboardAdthriveContent;